// * * * * * * * * * * * * * * * * *
//
// A11Y : RGAA : Ticket https://godzilla.serv.cdc.fr/browse/CONS-234
// Supprimer les attributs size des input des formulaires
//
// * * * * * * * * * * * * * * * * *
var fn_a11y_form_size = function () {
    $('form input[type="text"]').removeAttr('size');
}


// * * * * * * * * * * * * * * * * *
//
// A11Y : RGAA : iframe
//
// * * * * * * * * * * * * * * * * *
// var fn_a11y_iframe = function () {
//     // Ticket RGAA : iframe
//     // Ajoute la classe embed-responsive-item sur tous les iframes
//     // Les styles en inline sur les iframe doivent être déportés en CSS
//     $('iframe').addClass('embed-responsive-item').removeAttr('style').removeAttr('width').removeAttr('height').removeAttr('frameborder').removeAttr('allowfullscreen');

//     // Ticket RGAA : Les iframe doivent toujours avoir un title (même simple)
//     // Ici, on cible si y a un reCaptcha de Google
//     $('.g-recaptcha iframe').attr('title', 'Captcha');
// }


// SKIP LINK tabindex
// httphttps://webaim.org/techniques/skipnav/s://webaim.org/techniques/skipnav/
// https://www.bignerdranch.com/blog/web-accessibility-skip-navigation-links/
var fn_a11y_focus_tabindex = function () {
        // bind a click event to the 'skip' link
        $(".skip-links__link").click(function(event){

            // strip the leading hash and declare
            // the content we're skipping to
            var skipTo="#"+this.href.split('#')[1];

            // Setting 'tabindex' to -1 takes an element out of normal
            // tab flow but allows it to be focused via javascript
            $(skipTo).attr('tabindex', -1).on('blur focusout', function () {

                // when focus leaves this element,
                // remove the tabindex attribute
                $(this).removeAttr('tabindex');

            }).focus(); // focus on the content container
        });
    };
//

